import React from "react";
import classes from "./NavHumburger.module.css";
import ButtonLink from "../utils/ButtonLink";
import { useState } from "react";
export default function NavHumburger() {
  const [showHamList, setShowHamList] = useState(false);

  const hamHandler = () => {
    setShowHamList((state) => !state);
  };

  return (
    <div onClick={hamHandler} className={classes.navHumburgerMain}>
      <div className={classes.navHumburger}>
        <div className={classes.lineOne}></div>
        <div className={classes.lineTwo}></div>
        <div className={classes.lineThree}></div>
      </div>
      {showHamList && (
        <div className={classes.navHumburgerList}>
          <ButtonLink to="all-products" style={{ width: "100%" }}>
            All Products
          </ButtonLink>
          <ButtonLink to="wine" style={{ width: "100%" }}>
            Wine
          </ButtonLink>
          <ButtonLink to="beer" style={{ width: "100%" }}>
            Beer
          </ButtonLink>
          <ButtonLink to="spirits" style={{ width: "100%" }}>
            Spirits
          </ButtonLink>
        </div>
      )}
    </div>
  );
}
